var _g, _path, _g2, _path2, _path3, _path4, _g3, _circle, _path5, _g4, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 467.668 467.668",
    width: 512,
    height: 512,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2f4859"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.541 340.605s23.102 24.976 16.859 52.449h26.849l-18.107-52.449h-25.601zM317.19 340.605s-23.102 24.976-16.859 52.449h-26.849l18.107-52.449h25.601zM452.683 68.371H78.049c-8.117 0-14.985 6.868-14.985 14.985v241.639c0 8.117 6.868 14.985 14.985 14.985h374.634c8.117 0 14.985-6.868 14.985-14.985V83.98c0-8.741-6.868-15.609-14.985-15.609z",
    "data-original": "#2F4859"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.439 295.024v31.22c0 9.99 6.868 18.732 14.985 18.732h375.259c8.117 0 14.985-8.117 14.985-18.732v-31.22H62.439z",
    "data-original": "#EBF0F3",
    fill: "#ebf0f3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#64798a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-original": "#64798A",
    d: "M87.415 91.473h355.902v203.551H87.415zM278.478 319.376c0 7.493-6.244 13.112-13.737 13.112s-13.737-6.244-13.737-13.112c0-7.493 6.244-13.112 13.737-13.112 7.493-.001 13.737 5.619 13.737 13.112z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.668 207.61c-.624-1.249-1.249-2.498-1.873-4.371 0 1.249.624 2.498 1.873 4.371z",
    "data-original": "#E1E6E9",
    fill: "#e1e6e9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-original": "#D5D6DB",
    fill: "#d5d6db",
    d: "M109.268 127.688h151.727v11.863H109.268zM109.268 157.034h151.727v11.863H109.268zM109.268 185.756h151.727v11.863H109.268zM109.268 215.102h151.727v11.863H109.268zM196.059 389.307h139.239v21.854H196.059z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M418.341 22.166v184.82c0 7.493-5.62 13.112-13.112 13.112h-97.405c-6.868 0-13.112-5.62-13.112-13.112V22.166c0-7.493 5.62-13.112 13.112-13.112h97.405c7.493.624 13.112 6.244 13.112 13.112z",
    "data-original": "#44C4A1",
    fill: "#44c4a1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#e1e6e9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-original": "#E1E6E9",
    d: "M304.702 34.654H409.6v161.093H304.702zM374.634 24.039h-34.966c-1.249 0-2.498-1.249-2.498-2.498s1.249-2.498 2.498-2.498h34.966c1.249 0 2.498 1.249 2.498 2.498-.625 1.874-1.249 2.498-2.498 2.498z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.927,
    cy: 22.166,
    r: 1.873,
    "data-original": "#E1E6E9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 357.151,
    cy: 207.61,
    r: 10.615,
    "data-original": "#D5D6DB",
    fill: "#d5d6db"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.117 231.961H26.849C11.863 231.961 0 243.824 0 258.81v172.956c0 14.985 11.863 26.849 26.849 26.849h109.268c14.985 0 26.849-11.863 26.849-26.849V258.81c0-14.986-11.864-26.849-26.849-26.849z",
    "data-original": "#2F4859",
    fill: "#2f4859"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#e1e6e9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-original": "#E1E6E9",
    d: "M10.615 258.185h141.737v172.956H10.615zM104.898 247.571H67.434c-1.249 0-2.498-1.249-2.498-2.498s1.249-2.498 2.498-2.498h37.463c1.249 0 2.498 1.249 2.498 2.498s-1.249 2.498-2.497 2.498z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.068,
    cy: 245.073,
    r: 2.498,
    "data-original": "#E1E6E9"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.161 444.878c0 5.62-4.371 9.99-9.99 9.99-5.62 0-9.99-4.371-9.99-9.99 0-5.62 4.371-9.99 9.99-9.99s9.99 4.371 9.99 9.99z",
    "data-original": "#FFFFFF",
    className: "analytics_svg__active-path",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.663 444.878c0 3.746-3.122 6.868-6.868 6.868s-6.868-3.122-6.868-6.868 3.122-6.868 6.868-6.868c3.746 0 6.868 3.122 6.868 6.868z",
    "data-original": "#2F4859",
    fill: "#2f4859"
  })));
}
export default __webpack_public_path__ + "efa4d373364ccae4417a3d92ed2f982d.svg";
export { SvgAnalytics as ReactComponent };